import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { resetCurrentApplication } from '~/store/covenants/slice.ts';
import { fetchApplication } from '~/store/covenants/thunks/applicationThunks.ts';
import { AppDispatch } from '~/store/store.ts';

export const useCovenantsApplicationInitialization = ({
  applicationId,
  contragentId,
}: {
  applicationId?: string;
  contragentId: number;
}) => {
  const dispatch = useDispatch<AppDispatch>();

  useEffect(() => {
    if (!applicationId || !contragentId) return;

    const loadData = async () => {
      try {
        await dispatch(fetchApplication({ contragentId, applicationId })).unwrap();
      } catch (error) {
        console.error('Помилка ініціалізації даних:', error);
      }
    };

    void loadData();

    return () => {
      dispatch(resetCurrentApplication());
    };
  }, [applicationId, contragentId, dispatch]);
};
